module.exports = __webpack_public_path__ + "static/ltcbodoni-00f0c5cec4e533b2378a77aca02af631.woff";